import React from 'react';

interface FullPageLoaderProps {
    isLoading: boolean;
    message?: string;
    progressPercentage?: number;
}

export const FullPageLoader: React.FC<FullPageLoaderProps> = ({
    isLoading,
    message = 'Processing request... Please wait.',
    progressPercentage
}) => {
    if (!isLoading) return null;

    return (
        <div
            id="loading-overlay"
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(15, 23, 42, 0.45)',
                backdropFilter: 'blur(4px)',
                zIndex: 99999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'auto'
            }}
        >
            <div
                style={{
                    backgroundColor: '#ffffff',
                    padding: '30px 40px',
                    borderRadius: '16px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    border: '1px solid #e2e8f0',
                    minWidth: '300px',
                    maxWidth: '420px',
                    textAlign: 'center'
                }}
            >
                {/* CSS Spinner */}
                <div
                    style={{
                        width: '48px',
                        height: '48px',
                        border: '4px solid #e2e8f0',
                        borderTop: '4px solid #0284c7',
                        borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite'
                    }}
                />
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
                <div style={{ fontSize: '15px', fontWeight: 600, color: '#0f172a', lineHeight: 1.4 }}>
                    {message}
                </div>
                {progressPercentage !== undefined && (
                    <div style={{ width: '100%', marginTop: '8px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: 600, color: '#0284c7', marginBottom: '6px' }}>
                            <span>Progress</span>
                            <span>{progressPercentage}%</span>
                        </div>
                        <div style={{ width: '100%', backgroundColor: '#f1f5f9', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
                            <div style={{ width: `${progressPercentage}%`, backgroundColor: '#0284c7', height: '100%', transition: 'width 0.2s ease' }} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FullPageLoader;
